import { endRoute } from '$shared/utils/routes';

export const logoutRoutes = {
  legacyLogout: endRoute('/legacy-logout'),
};
